import { withRouter } from "react-router"

export default Component => withRouter(Component);
